<svg
  class="me-1"
  [ngClass]="sizeClass"
  [attr.id]="iconId + '-icon'"
  (click)="onClickIcon($event)"
  [attr.role]="role"
  [attr.aria-label]="ariaLabel"
  (keydown.enter)="onClickIcon($event)"
  (keydown.space)="onClickIcon($event)"
>
  <use [attr.xlink:href]="'assets/icons/svg-sprite.svg#' + name"></use>
</svg>
